<template>
  <h2 class="content-block">Manufacturer Details</h2>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>
  <DxToolbar class="menubar">
    <DxItem
        :options="cancelButtonOptions"
        location="before"
        widget="dxButton"
      />
    <DxItem
        :options="saveButtonOptions"
        location="before"
        widget="dxButton"
      />
  </DxToolbar>

  <div class="content-block dx-card responsive-paddings">
    <DxForm id="form" 
        :form-data="manufacturers" 
        :label-mode="outside" 
        :read-only="false" 
        :show-colon-after-label="true"
        :label-location="top" 
        :col-count="1" 
        :min-col-width="300" 
        :width="null"
        :items="['manufacturerId', 'manufacturerName']">
      >
      <DxSimpleItem data-field="manufacturerId"  :editor-options="{readOnly: true}" />
      <DxSimpleItem data-field="manufacturerName" />
    </DxForm>
  </div>
  </div>
</template>

<script>

import DxForm, { DxSimpleItem } from "devextreme-vue/form";
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';

export default {
  components: {
    DxForm, 
    DxSimpleItem, 
    DxToolbar,
    DxItem
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      cancelButtonOptions: {
        icon: 'revert',
        onClick: () => {
          //this.refreshData();
          this.$router.go(-1);
        },
      },
      saveButtonOptions: {
        icon: 'save',
        onClick: () => {
          if (this.manufacturers.manufacturerId==0)
          {
            this.$store.dispatch('manufacturers/addManufacturer', this.manufacturers);
            this.$emit('recordUpdated');
          }
          else
          {
            this.$store.dispatch('manufacturers/updateManufacturer', this.manufacturers);
            this.$emit('recordUpdated');
          }
        },
      },
    };
  },
  computed: {
    currentRecordId() {
      return this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1); 
    },
    manufacturers() {
      return this.$store.getters["manufacturers/getCurrentManufacturer"];
    },
  },
  methods: {
    refreshData(){
      this.loadPageData();
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("manufacturers/loadManufacturer", { id: this.currentRecordId });
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.menubar{
  padding: 0 60px 0 60px ;
}
</style>
